import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { OnboardingData } from '../types';

/**
 * T042: useStoreScore hook.
 * Fetches GET /api/onboarding, cached with TanStack Query.
 */
export function useStoreScore() {
  return useQuery<OnboardingData>({
    queryKey: ['onboarding'],
    queryFn: () => api.get<OnboardingData>('/store/onboarding'),
    staleTime: 30_000, // 30 seconds
  });
}
